import { render } from "./Button-icon-border.vue?vue&type=template&id=cfd8305e&scoped=true"
import script from "./Button-icon-border.vue?vue&type=script&lang=js"
export * from "./Button-icon-border.vue?vue&type=script&lang=js"

import "./Button-icon-border.vue?vue&type=style&index=0&id=cfd8305e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd8305e"]])

export default __exports__